import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { EMAIL_REGEX } from 'common-constants/validation';

const InputEmail = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="email"
      control={control}
      defaultValue={prefill}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: EMAIL_REGEX,
          message: 'Please check that your email is in the format: name@domain.com',
        },
      }}
    >
      <TextField
        fullWidth
        type="email"
        label="Email Address"
      />
    </ValidatedTextField>
  );
};

export default InputEmail;
